import { render } from "./customer-icon.vue?vue&type=template&id=9ad8ea6a&scoped=true&ts=true"
import script from "./customer-icon.vue?vue&type=script&lang=ts"
export * from "./customer-icon.vue?vue&type=script&lang=ts"

import "./customer-icon.vue?vue&type=style&index=0&id=9ad8ea6a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ad8ea6a"]])

export default __exports__